import { useMemo } from 'react'
import { useEngagementNavigation } from '@/contexts/engagement-navigation-context'

export interface FormNavigationItem {
  id: string
  label: string
  completed: boolean
  active: boolean
}

interface UseFormNavigationItemsParams {
  completedSections: Record<string, boolean>
  hiddenSections: Record<string, boolean>
}

export function useFormNavigationItems({
  completedSections,
  hiddenSections
}: UseFormNavigationItemsParams): FormNavigationItem[] {
  const { sections, activeSection } = useEngagementNavigation()
  
  return useMemo(() => 
    sections
      .filter(section => !hiddenSections[section.id])
      .map(section => ({
        id: section.id,
        label: section.label,
        completed: completedSections[section.id] || false,
        active: activeSection === section.id
      }))
  , [sections, completedSections, hiddenSections, activeSection])
}

